import { Button, ButtonProps } from 'antd';
import { ButtonType } from 'antd/lib/button';
import clsx from 'classnames';
import React, { FC } from 'react';
import './index.scss';

export interface TdsButtonProps extends Omit<ButtonProps, 'type'> {
  type?: ButtonType | 'light';
};

export const TdsButton: FC<TdsButtonProps> = (props) => {
  const { className, type, ...rest } = props;

  return (
        <Button
    type={type === 'light' ? 'default' : type}
    className={clsx('tds-button', type === 'light' ? 'tds-button-light' : '', className)}
    {...rest}
  />
  );
};
